import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconReactNative = ({
  title = "React on rails",
  viewBoxWidth = 80,
  viewBoxHeight = 72,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g
      id="1440-RoR"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="New-Services" transform="translate(-192.000000, -4100.000000)">
        <g id="Group-19" transform="translate(192.000000, 4096.000000)">
          <g id="React-RoR">
            <rect id="Rectangle" x="0" y="0" width="80" height="80" />
            <circle
              id="Oval-1"
              fill="#00D8FF"
              fillRule="nonzero"
              cx="40.1332149"
              cy="39.6003552"
              r="15"
            />
            <path
              d="M40,55.8081705 C29.982238,55.8081705 21.2291297,54.6287744 14.678508,52.383659 C10.4298401,50.9342806 6.82060391,49.0017762 4.24866785,46.7992895 C1.52042629,44.4689165 0.0710479574,41.9253996 0.0710479574,39.4671403 C0.0710479574,34.749556 5.24333925,30.1314387 13.9253996,27.1190053 C21.0301954,24.6465364 30.294849,23.268206 39.9857904,23.268206 C49.5062167,23.268206 58.642984,24.6039076 65.705151,27.0479574 C69.8401421,28.4689165 73.321492,30.3161634 75.7939609,32.3623446 C78.4795737,34.60746 79.9005329,37.0657194 79.9005329,39.4671403 C79.9005329,44.3694494 74.1172291,49.3285968 64.7957371,52.4120782 C58.2024867,54.6003552 49.39254,55.8081705 40,55.8081705 Z M40,26.678508 C30.8063943,26.678508 21.7122558,28.0142096 15.062167,30.330373 C7.07637655,33.1154529 3.4955595,36.9236234 3.4955595,39.4671403 C3.4955595,42.1101243 7.34635879,46.2735346 15.7868561,49.1580817 C21.982238,51.2753108 30.365897,52.3978686 40,52.3978686 C49.0373002,52.3978686 57.4635879,51.2611012 63.7300178,49.1722913 C72.4973357,46.259325 76.5044405,42.0959147 76.5044405,39.4671403 C76.5044405,38.1172291 75.4813499,36.5257549 73.6198934,34.9769094 C71.4742451,33.1865009 68.348135,31.5523979 64.6110124,30.259325 C57.8898757,27.9573712 49.1509769,26.678508 40,26.678508 Z"
              id="Shape-1"
              fill="#00D8FF"
              fillRule="nonzero"
            />
            <path
              d="M23.8152753,75.0195382 C22.365897,75.0195382 21.0870337,74.7069272 20.0071048,74.0817052 C15.928952,71.722913 14.5079929,64.9307282 16.2273535,55.9076377 C17.634103,48.5044405 21.0728242,39.8081705 25.9182948,31.410302 C30.678508,23.1687389 36.3907638,15.9218472 42.0319716,11.0195382 C45.3285968,8.14920071 48.6678508,6.04618117 51.6802842,4.93783304 C54.9626998,3.73001776 57.8046181,3.73001776 59.8792185,4.92362345 C64.1278863,7.36767318 65.5346359,14.8703375 63.5452931,24.4760213 C62.1385435,31.2966252 58.7850799,39.5239787 54.0959147,47.6660746 C49.0941385,56.3339254 43.6944938,63.3250444 38.4795737,67.8863233 C35.0976909,70.8419183 31.616341,73.0017762 28.4333925,74.1243339 C26.7708703,74.7211368 25.2078153,75.0195382 23.8152753,75.0195382 Z M27.3818828,32.2628774 L28.8596803,33.1154529 C24.2699822,41.0728242 20.8738899,49.6127886 19.5666075,56.5470693 C17.9893428,64.8596803 19.5097691,69.8614565 21.6980462,71.1261101 C22.2380107,71.4387211 22.9484902,71.6092362 23.8152753,71.6092362 C26.642984,71.6092362 31.0905861,69.8188277 36.2344583,65.3285968 C41.1651865,61.0230906 46.3232682,54.3161634 51.1403197,45.9751332 C55.6589698,38.1456483 58.8703375,30.2735346 60.2060391,23.8081705 C62.0674956,14.7566607 60.4618117,9.21492007 58.1740675,7.89342806 C57.008881,7.22557726 55.1190053,7.31083481 52.8454707,8.14920071 C50.2166963,9.11545293 47.2468917,11.0053286 44.2628774,13.6056838 C38.9058615,18.2664298 33.4351687,25.2007105 28.8596803,33.1296625 L27.3818828,32.2628774 Z"
              id="Shape-2"
              fill="#00D8FF"
              fillRule="nonzero"
            />
            <path
              d="M56.1847247,75.062167 C52.3197158,75.062167 47.4174067,72.731794 42.3019538,68.3268206 C36.589698,63.410302 30.7779751,56.0923623 25.9182948,47.6944938 L25.9182948,47.6944938 C21.1438721,39.4529307 17.7335702,30.8845471 16.2984014,23.5381883 C15.4600355,19.2468917 15.30373,15.3108348 15.8436945,12.1420959 C16.4404973,8.68916519 17.8472469,6.23090586 19.9360568,5.02309059 C24.1705151,2.56483126 31.374778,5.09413854 38.7069272,11.616341 C43.9076377,16.2344583 49.3641208,23.2539964 54.0674956,31.3818828 C59.0834813,40.0497336 62.4511545,48.2202487 63.7868561,55.0124334 C64.6536412,59.4174067 64.7957371,63.5097691 64.1847247,66.8348135 C63.5310835,70.3730018 62.053286,72.8880995 59.9218472,74.1243339 C58.8561279,74.749556 57.5914742,75.062167 56.1847247,75.062167 Z M28.8738899,45.9893428 C33.4777975,53.946714 39.1900533,61.1509769 44.5328597,65.740675 C50.9413854,71.2539964 56.0284192,72.4476021 58.2309059,71.1687389 C60.5186501,69.8472469 62.1953819,64.4333925 60.4618117,55.6802842 C59.1829485,49.2575488 55.9573712,41.4422735 51.1261101,33.1012433 C46.5932504,25.2717584 41.3783304,18.5506217 36.4476021,14.1740675 C29.5417407,8.03552398 23.9431616,6.65719361 21.6554174,7.97868561 C20.4902309,8.64653641 19.6234458,10.3374778 19.2113677,12.7246892 C18.7424512,15.4813499 18.8845471,19.0053286 19.651865,22.8845471 C21.0159858,29.8614565 24.2841918,38.0603908 28.8738899,45.9893428 L28.8738899,45.9893428 Z"
              id="Shape-3"
              fill="#00D8FF"
              fillRule="nonzero"
            />
          </g>
          <g id="Ruby" transform="translate(28.000000, 29.000000)">
            <rect id="Rectangle" x="0" y="0" width="24" height="24" />
            <g id="Group-8" transform="translate(-0.000000, 3.000000)">
              <polygon
                id="Rectangle-1"
                fill="#990000"
                points="14.8314607 5.46067416 24 5.46067416 12.0002244 18.8764045"
              />
              <polygon
                id="Rectangle-2"
                fill="#FA7B7C"
                points="6.50146603e-13 5.46067416 9.16853933 5.46067416 12.0002244 18.8764045"
              />
              <polygon
                id="Rectangle-3"
                fill="#D50000"
                points="7.5505618 5.46067416 16.4494382 5.46067416 12.0002244 18.8764045"
              />
              <rect
                id="Rectangle-4"
                fill="#FA7B7C"
                x="3.97752809"
                y="5.32907052e-14"
                width="8.02247191"
                height="5.46067416"
              />
              <rect
                id="Rectangle-Copy-9"
                fill="#FD0101"
                x="12"
                y="5.32907052e-14"
                width="7.95505618"
                height="5.46067416"
              />
              <polygon
                id="Rectangle-5"
                fill="#990000"
                points="7.5505618 5.46067416 16.4494382 5.46067416 12 5.32907052e-14"
              />
              <polygon
                id="Rectangle-Copy-7"
                fill="#D50000"
                points="16.4494382 5.46067416 24 5.46067416 19.8202247 5.32907052e-14"
              />
              <polygon
                id="Rectangle-Copy-8"
                fill="#FD0101"
                points="1.97175609e-13 5.46067416 7.5505618 5.46067416 3.97752809 5.32907052e-14"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg.Icon>
)

export default IconReactNative
